var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { useGlobalContext } from '@honeycomb/data';
import { useBreakpoints, Styler, Button, TypographyBody, Notification, Dialog, DialogContent, DialogFooter, DialogHeader, } from '@honeycomb/ui-core';
import { interjectResourceString, pluraliseCount } from '../../../utils';
export function FiltersDialog(_a) {
    var { children, loading, filteredDataCount = 0, onClose } = _a, other = __rest(_a, ["children", "loading", "filteredDataCount", "onClose"]);
    const { resourceStrings: { MODAL_FILTER_RESULTS_TITLE, NORESULTS_MATCHING_FILTERS_MAIN, NORESULTS_MATCHING_FILTERS_FLIGHTS_SUB, FILTERS_DIALOG_BUTTON_LABEL, FILTERS_DIALOG_BUTTON_LABEL_SINGLUAR, FILTERS_DIALOG_BUTTON_LABEL_LOADING, }, } = useGlobalContext();
    const { mediumUp } = useBreakpoints();
    const buttonLabel = useMemo(() => {
        if (loading) {
            return FILTERS_DIALOG_BUTTON_LABEL_LOADING;
        }
        return pluraliseCount(filteredDataCount, {
            singular: FILTERS_DIALOG_BUTTON_LABEL_SINGLUAR,
            plural: interjectResourceString(FILTERS_DIALOG_BUTTON_LABEL, filteredDataCount),
        });
    }, [
        FILTERS_DIALOG_BUTTON_LABEL,
        FILTERS_DIALOG_BUTTON_LABEL_LOADING,
        FILTERS_DIALOG_BUTTON_LABEL_SINGLUAR,
        filteredDataCount,
        loading,
    ]);
    return (React.createElement(Dialog, Object.assign({ position: mediumUp ? 'drawer-left' : 'centered', size: "m", fullScreen: "mobile-only", onClose: onClose }, other),
        React.createElement(DialogHeader, { withCloseButton: true }, MODAL_FILTER_RESULTS_TITLE),
        React.createElement(DialogContent, { bg: "background.offset" },
            React.createElement(Styler, { py: 4 },
                !loading && filteredDataCount === 0 && (React.createElement(Notification, { color: "info", variant: "compact", mb: 5 },
                    React.createElement(TypographyBody, { weight: "bold", "data-id": "no-results-text" }, NORESULTS_MATCHING_FILTERS_MAIN),
                    React.createElement("p", { "data-id": "no-results-sub-text" }, NORESULTS_MATCHING_FILTERS_FLIGHTS_SUB))),
                children)),
        React.createElement(DialogFooter, null,
            React.createElement(Button, { "data-id": "view-matches", color: "callToAction", size: "l", fullWidth: true, disabled: !filteredDataCount, onClick: () => {
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                }, loading: loading }, buttonLabel))));
}
